export interface ComicCategory {
  slug: string;
  name: string;
  description: string;
  coverImage: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface ComicReview {
  id: string;
  author: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  likes: number;
}

export interface ComicArticle {
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  longDescription: string;
  status: string;
  totalViews: string;
  totalChapters: number;
  rating: number;
  ratingPercent: string;
  tags: string[];
  chapters: ComicChapter[];
  reviews: ComicReview[];
  updatedAt: string;
}

export const categories: ComicCategory[] = [
  {
    slug: 'love',
    name: '恋爱漫画',
    description: '甜蜜浪漫的韩国恋爱漫画，涵盖校园、职场、契约婚姻等多元题材',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20style%20illustration%2C%20soft%20pink%20and%20cream%20background%2C%20two%20characters%20in%20tender%20moment%2C%20cherry%20blossom%20petals%2C%20dreamy%20atmosphere%2C%20clean%20manhwa%20art%20style%2C%20warm%20lighting%2C%20gentle%20romantic%20mood%2C%20simple%20composition&width=800&height=1067&seq=category-love-01&orientation=portrait',
  },
  {
    slug: 'fantasy',
    name: '奇幻漫画',
    description: '穿越异世界、魔法冒险题材韩漫，宏大世界观与精美画风并存',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20art%2C%20magical%20world%20with%20floating%20castles%2C%20mystical%20blue%20and%20gold%20tones%2C%20epic%20character%20in%20flowing%20robes%2C%20dramatic%20lighting%2C%20manhwa%20illustration%20style%2C%20clean%20composition%2C%20warm%20glowing%20accents%2C%20ethereal%20atmosphere&width=800&height=1067&seq=category-fantasy-01&orientation=portrait',
  },
  {
    slug: 'action',
    name: '动作漫画',
    description: '热血战斗、江湖武侠类韩漫，精彩打斗场面与紧凑剧情',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20art%2C%20dynamic%20fighting%20pose%2C%20dramatic%20red%20and%20dark%20tones%2C%20martial%20arts%20scene%2C%20intense%20energy%20effects%2C%20manhwa%20illustration%20style%2C%20bold%20composition%2C%20clean%20background%2C%20powerful%20atmosphere&width=800&height=1067&seq=category-action-01&orientation=portrait',
  },
  {
    slug: 'thriller',
    name: '惊悚漫画',
    description: '悬疑推理、恐怖惊悚类韩漫，烧脑剧情扣人心弦',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20art%2C%20mysterious%20dark%20atmosphere%2C%20suspenseful%20scene%2C%20deep%20purple%20and%20black%20tones%2C%20shadowy%20figure%2C%20manhwa%20illustration%20style%2C%20dramatic%20lighting%2C%20tense%20mood%2C%20clean%20composition&width=800&height=1067&seq=category-thriller-01&orientation=portrait',
  },
  {
    slug: 'bl',
    name: '耽美漫画',
    description: '高人气韩国BL漫画，唯美画风与感人故事',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20webtoon%20style%2C%20two%20male%20characters%20in%20soft%20romantic%20scene%2C%20pastel%20mint%20and%20cream%20tones%2C%20gentle%20atmosphere%2C%20clean%20manhwa%20art%2C%20beautiful%20illustration%2C%20warm%20lighting%2C%20emotional%20expression&width=800&height=1067&seq=category-bl-01&orientation=portrait',
  },
  {
    slug: 'drama',
    name: '剧情漫画',
    description: '深度剧情、社会题材韩漫，引人深思的优秀作品',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20art%2C%20emotional%20slice%20of%20life%20scene%2C%20warm%20brown%20and%20cream%20tones%2C%20character%20in%20contemplation%2C%20manhwa%20illustration%20style%2C%20soft%20natural%20lighting%2C%20thoughtful%20atmosphere%2C%20clean%20composition&width=800&height=1067&seq=category-drama-01&orientation=portrait',
  },
];

export const featuredComics: ComicArticle[] = [
  {
    slug: 'secretary-escapes',
    title: '秘书的逃脱计划',
    author: '金秀雅',
    category: '恋爱漫画',
    categorySlug: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20elegant%20female%20office%20worker%2C%20soft%20rose%20and%20cream%20background%2C%20romantic%20comedy%20style%2C%20clean%20webtoon%20illustration%2C%20warm%20lighting%2C%20professional%20yet%20dreamy%20atmosphere&width=800&height=1067&seq=comic-featured-01&orientation=portrait',
    description: '总裁秘书暗地里筹划着逃离这个牢笼，却发现老板的秘密越来越多...',
    longDescription: '李素妍是赫赫有名的DK集团总裁秘书，三年来她兢兢业业，却始终觉得这份工作没有意义。某天她偶然发现了总裁的秘密——原来他每晚都在地下格斗场打黑拳。从此她的逃跑计划变得越来越复杂，而她和总裁之间的关系也发生了微妙的变化。',
    status: '连载中',
    totalViews: '1280万',
    totalChapters: 86,
    rating: 4.8,
    ratingPercent: '96%',
    tags: ['恋爱', '职场', '喜剧', '总裁'],
    chapters: [
      { id: 'ch-86', title: '第86话 - 无法隐藏的心意', number: 86, updatedAt: '2026-07-02' },
      { id: 'ch-85', title: '第85话 - 意外的访客', number: 85, updatedAt: '2026-06-25' },
      { id: 'ch-84', title: '第84话 - 深夜的对话', number: 84, updatedAt: '2026-06-18' },
      { id: 'ch-83', title: '第83话 - 决心的瞬间', number: 83, updatedAt: '2026-06-11' },
      { id: 'ch-82', title: '第82话 - 隐藏的真相', number: 82, updatedAt: '2026-06-04' },
    ],
    reviews: [
      { id: 'r1', author: '漫画迷小樱', avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20pink%20background%2C%20simple%20illustration%2C%20warm%20expression&width=120&height=120&seq=avatar-reviewer-01&orientation=squarish', rating: 5, content: '这部真的太好看了！画风绝美，剧情也超有意思，每次更新都第一时间追！女主的性格太讨喜了，不是那种傻白甜，智商在线！', date: '2026-07-01', likes: 328 },
      { id: 'r2', author: '深夜追漫人', avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20cat%20avatar%2C%20soft%20cream%20background%2C%20cute%20minimalist%20illustration&width=120&height=120&seq=avatar-reviewer-02&orientation=squarish', rating: 5, content: '熬夜看到最新一话，根本停不下来。男主的人设太绝了，表面冷酷总裁私下格斗选手，反差萌简直犯规。', date: '2026-06-28', likes: 215 },
      { id: 'r3', author: '漫画推荐官', avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20boy%20avatar%2C%20warm%20beige%20background%2C%20friendly%20expression%2C%20clean%20illustration&width=120&height=120&seq=avatar-reviewer-03&orientation=squarish', rating: 5, content: '韩国漫画网的翻译质量很高，更新也快。这部是我今年的年度最佳韩漫之一，强烈推荐给喜欢恋爱喜剧的朋友！', date: '2026-06-20', likes: 189 },
    ],
    updatedAt: '2026-07-02',
  },
  {
    slug: 'magic-sword-hero',
    title: '魔剑英雄传',
    author: '李东浩',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20heroic%20character%20with%20magic%20sword%2C%20epic%20gold%20and%20blue%20tones%2C%20fantasy%20world%20background%2C%20clean%20webtoon%20illustration%2C%20dramatic%20lighting&width=800&height=1067&seq=comic-featured-02&orientation=portrait',
    description: '平凡少年获得传说中的魔剑，踏上拯救世界的征途，却发现敌人来自更远的地方...',
    longDescription: '在剑与魔法的世界里，一个从小被当作废物对待的少年韩振宇，意外唤醒了沉睡千年的魔剑"暗影之心"。从此他踏上了成为真正英雄的道路，却发现魔剑封印的真相远比想象中更加震撼——被封印的，竟是这个世界原本的守护者。',
    status: '连载中',
    totalViews: '960万',
    totalChapters: 124,
    rating: 4.7,
    ratingPercent: '94%',
    tags: ['奇幻', '冒险', '成长', '战斗'],
    chapters: [
      { id: 'ch-124', title: '第124话 - 远古的真相', number: 124, updatedAt: '2026-07-01' },
      { id: 'ch-123', title: '第123话 - 封印解开', number: 123, updatedAt: '2026-06-24' },
    ],
    reviews: [
      { id: 'r4', author: '幻想世界', avatar: 'https://readdy.ai/api/search-image?query=dragon%20simple%20anime%20style%20avatar%2C%20warm%20beige%20background%2C%20cute%20illustration&width=120&height=120&seq=avatar-reviewer-04&orientation=squarish', rating: 5, content: '世界观太宏大了，每次更新都像在看一部史诗电影。画风清奇，战斗场面超燃！', date: '2026-06-30', likes: 456 },
    ],
    updatedAt: '2026-07-01',
  },
  {
    slug: 'shadow-hunter',
    title: '暗影猎人',
    author: '朴志勋',
    category: '动作漫画',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20dark%20hunter%20character%2C%20dramatic%20red%20and%20black%20tones%2C%20intense%20pose%2C%20clean%20webtoon%20illustration%2C%20powerful%20atmosphere&width=800&height=1067&seq=comic-featured-03&orientation=portrait',
    description: '隐退的杀手被迫重出江湖，为了保护唯一的家人，他要面对整个地下世界...',
    longDescription: '曾是地下世界传奇杀手的姜道贤，为女儿金盆洗手五年。但当年被他摧毁的暗影组织卷土重来，绑架了他的女儿作为人质。现在他必须在72小时内完成一项不可能的任务——刺杀现任韩国总统，才能换回女儿的性命。',
    status: '连载中',
    totalViews: '850万',
    totalChapters: 62,
    rating: 4.9,
    ratingPercent: '98%',
    tags: ['动作', '悬疑', '犯罪', '父爱'],
    chapters: [
      { id: 'ch-62', title: '第62话 - 倒计时', number: 62, updatedAt: '2026-07-03' },
    ],
    reviews: [],
    updatedAt: '2026-07-03',
  },
];

export const dailyUpdateComics: ComicArticle[] = [
  {
    slug: 'demon-king-academy',
    title: '魔王学院的不适任者',
    author: '崔允儿',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20academy%20manhwa%20cover%2C%20powerful%20student%20character%2C%20magic%20academy%20setting%2C%20soft%20blue%20and%20cream%20tones%2C%20clean%20webtoon%20illustration&width=800&height=1067&seq=comic-daily-01&orientation=portrait',
    description: '被魔王学院判定为"不适任者"的少年，实际上是真正的魔王转世',
    longDescription: '',
    status: '连载中',
    totalViews: '720万',
    totalChapters: 98,
    rating: 4.6,
    ratingPercent: '92%',
    tags: ['奇幻', '校园', '转世'],
    chapters: [{ id: 'ch-98', title: '第98话', number: 98, updatedAt: '2026-07-03' }],
    reviews: [],
    updatedAt: '2026-07-03',
  },
  {
    slug: 'sweet-trap',
    title: '甜蜜陷阱',
    author: '韩智慧',
    category: '恋爱漫画',
    categorySlug: 'love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20sweet%20couple%20moment%2C%20pink%20and%20cream%20background%2C%20coffee%20shop%20setting%2C%20clean%20webtoon%20illustration%2C%20warm%20atmosphere&width=800&height=1067&seq=comic-daily-02&orientation=portrait',
    description: '咖啡店老板和神秘顾客之间甜蜜又危险的恋爱游戏',
    longDescription: '',
    status: '连载中',
    totalViews: '560万',
    totalChapters: 54,
    rating: 4.5,
    ratingPercent: '90%',
    tags: ['恋爱', '都市', '咖啡'],
    chapters: [{ id: 'ch-54', title: '第54话', number: 54, updatedAt: '2026-07-03' }],
    reviews: [],
    updatedAt: '2026-07-03',
  },
  {
    slug: 'revenge-of-villainess',
    title: '恶女的逆袭',
    author: '尹瑞妍',
    category: '剧情漫画',
    categorySlug: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20elegant%20female%20character%2C%20royal%20palace%20setting%2C%20warm%20brown%20and%20gold%20tones%2C%20clean%20webtoon%20illustration%2C%20dramatic%20atmosphere&width=800&height=1067&seq=comic-daily-03&orientation=portrait',
    description: '被诬陷为恶女处死的公爵千金，重生后开始了完美的复仇计划',
    longDescription: '',
    status: '连载中',
    totalViews: '2100万',
    totalChapters: 112,
    rating: 4.9,
    ratingPercent: '98%',
    tags: ['重生', '复仇', '宫廷'],
    chapters: [{ id: 'ch-112', title: '第112话', number: 112, updatedAt: '2026-07-03' }],
    reviews: [],
    updatedAt: '2026-07-03',
  },
];

export const testimonials = [
  {
    id: 't1',
    author: '刘思雨',
    role: '资深漫画读者',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20girl%20portrait%20avatar%2C%20warm%20peach%20background%2C%20friendly%20smile%2C%20clean%20illustration&width=120&height=120&seq=avatar-test-01&orientation=squarish',
    content: '韩国漫画网的更新速度真的太快了！比其他平台都要快半天以上，而且翻译质量也很好。下拉式阅读体验超棒，一口气能看好几话。已经推荐给所有喜欢韩漫的朋友了。',
    rating: 5,
  },
  {
    id: 't2',
    author: '陈浩然',
    role: '漫画博主',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20boy%20portrait%20avatar%2C%20warm%20beige%20background%2C%20friendly%20expression%2C%20clean%20illustration&width=120&height=120&seq=avatar-test-02&orientation=squarish',
    content: '作为漫画博主，我每天都要看大量韩漫。韩国漫画网的分类做得特别好，找漫画非常方便。而且每个作品的信息都很全，作者、更新状态一目了然，是我的每日必逛网站。',
    rating: 5,
  },
  {
    id: 't3',
    author: '王晓琳',
    role: '韩漫翻译',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20woman%20portrait%20avatar%2C%20soft%20pink%20background%2C%20warm%20smile%2C%20clean%20illustration&width=120&height=120&seq=avatar-test-03&orientation=squarish',
    content: '我自己就是韩漫行业的从业者，韩国漫画网对版权的重视让我很感动。他们坚持正版授权，为读者提供优质内容，也为创作者提供了应有的回报，这样的平台值得被更多人知道！',
    rating: 5,
  },
  {
    id: 't4',
    author: '张明远',
    role: '大学助教',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20man%20portrait%20avatar%2C%20warm%20gray%20background%2C%20gentle%20expression%2C%20clean%20illustration&width=120&height=120&seq=avatar-test-04&orientation=squarish',
    content: '课间休息时最喜欢打开韩国漫画网看看更新。手机版体验很好，下拉式阅读不累手。收藏夹功能也很好用，追的十几部漫画更新了都会提醒，非常贴心。',
    rating: 4,
  },
  {
    id: 't5',
    author: '林小蝶',
    role: '插画师',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20anime%20style%20artist%20girl%20avatar%2C%20soft%20mint%20background%2C%20creative%20expression%2C%20clean%20illustration&width=120&height=120&seq=avatar-test-05&orientation=squarish',
    content: '作为一个插画师，我对画风要求很高。韩国漫画网上的作品画风都太棒了，特别是奇幻类目下的作品，每一格的构图和用色都值得学习。这里不仅是阅读平台，也是我的灵感源泉！',
    rating: 5,
  },
];

export const siteStats = {
  totalComics: '12,000+',
  totalUsers: '580万',
  dailyActive: '82万',
  countries: '36',
};

export const mediaReviews = [
  {
    id: 'm1',
    source: '动漫资讯周刊',
    content: '韩国漫画网凭借其丰富的内容库和极速的更新频率，已经成为中文韩漫爱好者首选的阅读平台之一。其对下拉式阅读体验的优化尤为出色。',
    date: '2026-06-15',
  },
  {
    id: 'm2',
    source: '数字娱乐观察',
    content: '在国内韩漫平台中，韩国漫画网的分类系统和搜索体验处于领先地位。平台不仅覆盖主流题材，对小众类型也有很好的支持，满足了多元化的阅读需求。',
    date: '2026-05-20',
  },
  {
    id: 'm3',
    source: 'ACGN文化圈',
    content: '韩国漫画网在版权合规方面走在了行业前列，与多家韩国漫画工作室建立了正式合作关系，为读者提供正版授权内容的同时，也为创作者创造了价值。',
    date: '2026-04-08',
  },
];